import { LiveData } from '@toeverything/infra';

/**
 * Whether the phone layout shows the navigation rail. The rail lives in the app sidebar while its
 * toggle (the burger) lives in the first view's top bar, so both read this one state.
 */
export const mobileNavigationRailOpen$ = new LiveData(false);

export function setMobileNavigationRailOpen(open: boolean) {
  if (mobileNavigationRailOpen$.value !== open) {
    mobileNavigationRailOpen$.next(open);
  }
}

export function toggleMobileNavigationRail() {
  setMobileNavigationRailOpen(!mobileNavigationRailOpen$.value);
}
